import TimeHelper from '../../utils/time';

export const parseDesignCollectiveListParams = (createDate?: string): any => {
    let params = '';
    if (createDate) params += 'Date=' + createDate + '&';
    return params;
};

export const buildAttachmentUrls = (attachments?: Array<{ attachmentUrl?: string }>): string => {
    if (!attachments?.length) {
        return '';
    }

    return attachments.reduce((urls, attachment) => `${urls} ${attachment.attachmentUrl ?? ''} `, '');
};

export const mapDesignCollectiveExportRow = (item: any, enumCommentStatusFlowStatusTrName: Record<number, string>) => ({
    id: item.designCollectiveId || '-',
    date: TimeHelper.formatDateHour(item.createDate) || '-',
    fullName: item.fullName || '-',
    email: item.email || '-',
    phoneNumber: item.phoneNumber || '-',
    city: item.city || '-',
    address: item.address || '-',
    status: enumCommentStatusFlowStatusTrName[item.status],
    instagramUrl: item.instagramUrl,
    youtubeUrl: item.youtubeUrl || '-',
    twitterUrl: item.twitterUrl || '-',
    description: item.description || '-',
    attachment: buildAttachmentUrls(item.dCollectiveAttachment),
});
